// src/components/PendenciaForm.js
import React, { useState, useEffect } from "react";
import {
  FormContainer,
  FormInnerContainer,
  SubmitButton,
  CancelButton,
  Select,
  Input,
  Label,
  Row,
  Column
} from "../styles/StyledComponents";
import ReactSelect from "react-select";
import { getCustomers } from "../services/customerService";
import { getUsers } from "../services/userService";
import { deletePendencia , createPendencia, updatePendencia, uploadFotos, uploadDocumentos } from "../services/pendenciaService";
import Swal from "sweetalert2";

// Componente para exibir a foto
const FotoItem = ({ foto, onRemove, isLocalPreview }) => {
  const src = isLocalPreview
    ? foto
    : `${process.env.REACT_APP_BASE_URL}/uploads/pendencias/${foto}`;
  return (
    <div style={{ display: "inline-block", marginRight: "8px", position: "relative" }}>
      <a href={src} target="_blank" rel="noopener noreferrer">
        <img
          src={src}
          alt="Foto da pendência"
          style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
        />
      </a>
      <button
        type="button"
        onClick={() => onRemove(foto, isLocalPreview)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          background: "red",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "15px",
          height: "16px",
          cursor: "pointer",
          padding: "0px"
        }}
      >
        ×
      </button>
    </div>
  );
};

// Componente para exibir o documento
const DocumentItem = ({ doc, onRemove, isLocalPreview }) => {
  const src = isLocalPreview
    ? doc
    : `${process.env.REACT_APP_BASE_URL}/uploads/pendencias/${doc}`;
  return (
    <div style={{
      display: "inline-block",
      marginRight: "8px",
      padding: "4px 8px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      position: "relative"
    }}>
      <a href={src} target="_blank" rel="noopener noreferrer">
        Documento
      </a>
      <button
        type="button"
        onClick={() => onRemove(doc, isLocalPreview)}
        style={{
          position: "absolute",
          top: "-5px",
          right: "-5px",
          background: "red",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "15px",
          height: "15px",
          cursor: "pointer",
          padding: "0px",
          fontSize: "10px"
        }}
      >
        ×
      </button>
    </div>
  );
};

const PendenciaForm = ({
  visible,
  initialData = {},
  onCancel,
  isEditing,
  onSuccess,
  onChange,
  onFilesChange,
  onDeletePhoto,
  onDeleteDocumento
}) => {
  const [pendencia, setPendencia] = useState(initialData);
  const [customers, setCustomers] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  
  // Estados para arquivos
  const [localFiles, setLocalFiles] = useState([]);
  const [fotosPreview, setFotosPreview] = useState(initialData.fotos || []);
  const [localDocs, setLocalDocs] = useState([]);
  const [docPreviews, setDocPreviews] = useState(initialData.documentos || []);

  // Carrega clientes e técnicos (executa uma vez)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerData = await getCustomers(1, 100);
        const technicianData = await getUsers();
        setCustomers(customerData.customers);
        setTechnicians(
          technicianData.filter(user => 
            user.profile === "Tecnico" || user.profile === "Supervisor"
          )
        );
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    };
    fetchData();
  }, []);

  // Atualiza equipamentos com base no cliente selecionado
  useEffect(() => {
    if (pendencia.clienteId) {
      const cliente = customers.find(c => c._id === pendencia.clienteId);
      setEquipments(cliente?.equipment || []);
    }
  }, [pendencia.clienteId, customers]);

  // Carrega os dados iniciais somente na montagem
  useEffect(() => {
    setPendencia(initialData);
    setFotosPreview(initialData.fotos || []);
    setDocPreviews(initialData.documentos || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // executa apenas uma vez

  const handleChange = (e) => {
    setPendencia({ ...pendencia, [e.target.name]: e.target.value });
    if (onChange) {
      onChange(e);
    }
  };

  // Seleção de fotos
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setLocalFiles(prev => [...prev, ...files]);
    const previews = files.map(file => URL.createObjectURL(file));
    setFotosPreview(prev => [...prev, ...previews]);
    if (onFilesChange) {
      onFilesChange([...localFiles, ...files]);
    }
  };

  // Seleção de documentos
  const handleDocChange = (e) => {
    const files = Array.from(e.target.files);
    setLocalDocs(prev => [...prev, ...files]);
    const previews = files.map(file => URL.createObjectURL(file));
    setDocPreviews(prev => [...prev, ...previews]);
  };

  const handleRemoveFoto = (foto, isLocal) => {
    Swal.fire({
      title: "Tem certeza?",
      text: "Deseja realmente excluir esta foto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.isConfirmed) {
        if (!isLocal && onDeletePhoto && pendencia._id) {
          onDeletePhoto(foto);
  
          // Atualiza também o campo fotos no objeto pendência
          setPendencia((prev) => ({
            ...prev,
            fotos: (prev.fotos || []).filter((f) => f !== foto),
          }));
        }
  
        // Atualiza preview local
        setFotosPreview(prev => prev.filter(f => f !== foto));
        setLocalFiles(prev => prev.filter(file => URL.createObjectURL(file) !== foto));
  
        Swal.fire("Excluída!", "A foto foi excluída.", "success");
      }
    });
  };
  

  const handleRemoveDoc = (doc, isLocal) => {
    Swal.fire({
      title: "Tem certeza?",
      text: "Deseja realmente excluir este documento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.isConfirmed) {
        if (!isLocal && onDeleteDocumento && pendencia._id) {
          onDeleteDocumento(doc);
        }
        setDocPreviews(prev => prev.filter(d => d !== doc));
        setLocalDocs(prev => prev.filter(file => URL.createObjectURL(file) !== doc));
        Swal.fire("Excluído!", "O documento foi excluído.", "success");
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let nova;
      if (isEditing && pendencia._id) {
        nova = await updatePendencia(pendencia._id, pendencia);
      } else {
        nova = await createPendencia(pendencia);
      }
      if (localFiles.length > 0) {
        const resFotos = await uploadFotos(nova._id, localFiles);
        console.log("Fotos enviadas:", resFotos);
      }
      if (localDocs.length > 0) {
        const resDocs = await uploadDocumentos(nova._id, localDocs);
        console.log("Documentos enviados:", resDocs);
      }
      Swal.fire("Sucesso", "Pendência salva com sucesso!", "success");
      if (onSuccess) {
        onSuccess(nova);
      }
    } catch (error) {
      console.error("Erro no submit:", error);
      Swal.fire("Erro", "Erro ao salvar pendência.", "error");
    }
  };

  if (!visible) return null;

  const handleDelete = async () => {
    if (!pendencia._id) return;
  
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Esta ação é irreversível. Deseja realmente deletar esta pendência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, deletar",
      cancelButtonText: "Cancelar"
    });
  
    if (result.isConfirmed) {
      try {
        await deletePendencia(pendencia._id);
        Swal.fire("Deletado!", "A pendência foi removida com sucesso.", "success");
        if (onSuccess) {
          onSuccess(); // para atualizar a listagem, se necessário
        }
        if (onCancel) {
          onCancel(); // fecha o modal
        }
      } catch (error) {
        Swal.fire("Erro", "Erro ao tentar deletar a pendência.", "error");
      }
    }
  };

  // Mapeia os clientes para o formato aceito pelo react-select
  const customerOptions = customers.map(cliente => ({
    value: cliente._id,
    label: cliente.name
  }));

  // Define o valor selecionado com base no clienteId
  const selectedCustomer = customerOptions.find(option => option.value === pendencia.clienteId) || null;

  // Estilos customizados para o react-select, ajustando para o padrão dos inputs
  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "14px"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px"
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px"
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px"
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0
    })
  };

  return (
    <FormContainer visible={visible}>
      <FormInnerContainer>
        <form onSubmit={handleSubmit}>
          <Row columns={12}>
            <Column cols={12}>
              <h2>{isEditing ? "Editar Pendência" : "Nova Pendência"}</h2>
              <p>Complete os campos abaixo para criar ou editar uma pendência.</p>
            </Column>
          </Row>
          <Row columns={12}>
            <Column cols={12}>
              <Label>Cliente</Label>
              <ReactSelect
                name="clienteId"
                value={selectedCustomer}
                onChange={(selectedOption) =>
                  setPendencia({ ...pendencia, clienteId: selectedOption.value })
                }
                options={customerOptions}
                placeholder="Selecione ou pesquise um cliente..."
                isSearchable
                styles={customSelectStyles}
              />
            </Column>
            </Row>
          <Row columns={12}>
            <Column cols={6}>
              <Label>Tipo de Contrato</Label>
              <Input
                type="text"
                value={
                  customers.find(c => c._id === pendencia.clienteId)?.tipoContrato || "-"
                }
                disabled
              />
            </Column>
            <Column cols={6}>
              <Label>Equipamento</Label>
              <Select
                name="equipamentoNumero"
                value={pendencia.equipamentoNumero || ""}
                onChange={handleChange}
                required
              >
                <option value="">Selecione um equipamento</option>
                {equipments.map(equip => (
                  <option key={equip.equipmentNumber} value={equip.equipmentNumber}>
                    {equip.equipmentNumber} - {equip.type} - {equip.apelido}
                  </option>
                ))}
              </Select>
            </Column>
          </Row>
          <Row columns={12}>
            <Column cols={6}>
              <Label>Técnico</Label>
              <Select
                name="tecnico"
                value={pendencia.tecnico || ""}
                onChange={handleChange}
                required
              >
                <option value="">Selecione um técnico</option>
                {technicians.map(tecnico => (
                  <option key={tecnico._id} value={tecnico._id}>
                    {tecnico.name}
                  </option>
                ))}
              </Select>
            </Column>
            <Column cols={6}>
              <Label>Data do Apontamento</Label>
              <Input
                type="date"
                name="dataApontamento"
                value={pendencia.dataApontamento || ""}
                onChange={handleChange}
                required
              />
            </Column>
          </Row>
          <Row columns={12}>
            <Column cols={6}>
              <Label>Situação do Equipamento</Label>
              <Select
                name="situacaoEquipamento"
                value={pendencia.situacaoEquipamento || "Funcionando"}
                onChange={handleChange}
                
              >
                <option value="Funcionando">Funcionando</option>
                <option value="Parado">Parado</option>
              </Select>
            </Column>
            <Column cols={6}>
              <Label>Status da Pendência</Label>
              <Select
                name="statusPendencia"
                value={pendencia.statusPendencia || "Nova"}
                onChange={handleChange}
                
              >
                <option value="Nova">Nova</option>
                <option value="Aguardando Orçamento">Aguardando Orçamento</option>
                <option value="Aguardando Aprovação">Aguardando Aprovação</option>
                <option value="Agendada">Agendada</option>
                <option value="Concluída">Concluída</option>
              </Select>
            </Column>
            </Row>

            <Row columns={12}>
            <Column cols={6}>
              <Label>Tipo da Pendência</Label>
              <Select
                name="tpPendencia"
                value={pendencia.tpPendencia || ""}
                onChange={handleChange}
                
              >
                <option value="Orçamento">Orçamento</option>
                <option value="Sinistro">Sinistro</option>
                <option value="Mal Uso">Mal Uso</option>

              </Select>
            </Column>
</Row>



          <Row columns={12}>
            <Column cols={12}>
              <Label>Descrição da Pendência</Label>
              <Input
                type="text"
                name="descricaoPendencia"
                value={pendencia.descricaoPendencia || ""}
                onChange={handleChange}
                required
              />
            </Column>
          </Row>

          <Row columns={12}>
            <Column cols={6}>
              <Label>Técnico</Label>
              <Select
                name="tecnicoFechamento"
                value={pendencia.tecnicoFechamento || ""}
                onChange={handleChange}
              >
                <option value="">Selecione um técnico</option>
                {technicians.map(tecnico => (
                  <option key={tecnico._id} value={tecnico._id}>
                    {tecnico.name}
                  </option>
                ))}
              </Select>
            </Column>
            <Column cols={6}>
              <Label>Fechamento Pendencia</Label>
              <Input
                type="date"
                name="dataFechamento"
                value={pendencia.dataFechamento || ""}
                onChange={handleChange}
              />
            </Column>
          </Row>

          <Row columns={12}>
            <Column cols={12}>
              <Label>Obs. Fechamento da Pendência</Label>
              <Input
                type="text"
                name="obsFechamentoPendencia"
                value={pendencia.obsFechamentoPendencia || ""}
                onChange={handleChange}
              />
            </Column>
          </Row>


          {/* Upload de fotos */}
          <Row columns={12} mt={16}>
            <Column cols={12}>
              <Label>Fotos (evidências)</Label>
              <Input
                type="file"
                name="fotos"
                accept="image/*"
                multiple
                onChange={handleFileChange}
              />
            </Column>
          </Row>
          <Row columns={12} mt={8}>
            <Column cols={12}>
              {fotosPreview.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {fotosPreview.map((foto, index) => (
                    <FotoItem
                      key={index}
                      foto={foto}
                      onRemove={handleRemoveFoto}
                      isLocalPreview={foto.startsWith("blob:")}
                    />
                  ))}
                </div>
              )}
            </Column>
          </Row>
          {/* Upload de documentos */}
          <Row columns={12} mt={16}>
            <Column cols={12}>
              <Label>Documentos (PDF, DOC ou DOCX)</Label>
              <Input
                type="file"
                name="documentos"
                accept="application/pdf,.doc,.docx"
                multiple
                onChange={handleDocChange}
              />
            </Column>
          </Row>
          <Row columns={12} mt={8}>
            <Column cols={12}>
              {docPreviews.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {docPreviews.map((doc, index) => (
                    <DocumentItem
                      key={index}
                      doc={doc}
                      onRemove={handleRemoveDoc}
                      isLocalPreview={doc.startsWith("blob:")}
                    />
                  ))}
                </div>
              )}
            </Column>
          </Row>
          <Row columns={12}>
  <Column cols={12}>
    <Label>Notas gerais</Label>
    <textarea
      name="notasPendencia"
      value={pendencia.notasPendencia || ""}
      onChange={handleChange}
      rows={4}
      style={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontSize: "14px",
        fontFamily: "inherit",
        resize: "vertical",
      }}
    />
  </Column>
</Row>
          <Row columns={12} mt={32}>
  <Column cols={3}>
    <SubmitButton type="submit">
      {isEditing ? "Salvar" : "Criar Pendência"}
    </SubmitButton>
  </Column>
  <Column cols={3}>
    <CancelButton type="button" onClick={onCancel}>
      Cancelar
    </CancelButton>
  </Column>
  {isEditing && (
    <Column cols={3}>
      <CancelButton
        type="button"
        onClick={handleDelete}
        style={{ backgroundColor: "#d33", color: "#fff" }}
      >
        Deletar
      </CancelButton>
    </Column>
  )}
</Row>
        </form>
      </FormInnerContainer>
    </FormContainer>
  );
};

export default PendenciaForm;
